import Axios from 'axios';
var DeliverService = (function () {
    function DeliverService() {
    }
    DeliverService.prototype.getList = function (params) {
        return Axios.get('supplierclientapi/deliveryorder/list', { params: params });
    };
    DeliverService.prototype.getDetail = function (params) {
        return Axios.get('supplierclientapi/deliveryorder/detail', { params: params });
    };
    DeliverService.prototype.getDetailAddGoods = function (data) {
        return Axios.post('supplierclientapi/deliveryorder/detail_add_goods', data);
    };
    DeliverService.prototype.detailDelGoods = function (params) {
        return Axios.get('supplierclientapi/deliveryorder/detail_del_goods', { params: params });
    };
    DeliverService.prototype.getDeliveryOrderList = function (params) {
        return Axios.get('supplierclientapi/purchaseorder/delivery_order_list', { params: params });
    };
    DeliverService.prototype.getListGoods = function (params) {
        return Axios.post('supplierclientapi/deliveryorder/list_goods', params);
    };
    DeliverService.prototype.addDeliveryOrder = function (params) {
        return Axios.post('supplierclientapi/deliveryorder/create', params);
    };
    DeliverService.prototype.updateDeliveryOrder = function (params) {
        return Axios.post('supplierclientapi/deliveryorder/update', params);
    };
    DeliverService.prototype.splitDeliveryOrder = function (params) {
        return Axios.post('supplierclientapi/deliveryorder/split', params);
    };
    DeliverService.prototype.getGoodsList = function (params) {
        return Axios.get('supplierclientapi/deliveryorder/goods_list', { params: params });
    };
    DeliverService.prototype.getEditOrderInfo = function (params) {
        return Axios.get('supplierclientapi/deliveryorder/update_info', { params: params });
    };
    DeliverService.prototype.setAudit = function (params) {
        return Axios.get('supplierclientapi/deliveryorder/audit', { params: params });
    };
    DeliverService.prototype.setCancel = function (params) {
        return Axios.get('supplierclientapi/deliveryorder/cancel', { params: params });
    };
    DeliverService.prototype.getBusinessGoodsList = function (params) {
        return Axios.get('supplierclientapi/businessgoodsprice/goods_list', { params: params });
    };
    DeliverService.prototype.documentManualSync = function (params) {
        return Axios.post('supplierclientapi/deliveryorder/sync_document', params);
    };
    DeliverService.prototype.getGoodAlreadyBindLicenses = function (params) {
        return Axios.get('supplierclientapi/deliveryorder/document_list', { params: params });
    };
    DeliverService.prototype.getDeliveryOrderPrintDetail = function (params) {
        return Axios.get('supplierclientapi/deliveryorder/print_detail', { params: params });
    };
    DeliverService.prototype.getRefundDeliveryList = function (params) {
        return Axios.get('supplierclientapi/deliveryorder/refund_delivery_list', { params: params });
    };
    DeliverService.prototype.getRefundDeliveryDetail = function (params) {
        return Axios.get('/supplierclientapi/deliveryorder/refund_delivery_detail', { params: params });
    };
    DeliverService.prototype.getDeliveryOrderGoods = function (params) {
        return Axios.get('/supplierclientapi/deliveryorder/goods', { params: params });
    };
    DeliverService.prototype.getGoodstype = function (params) {
        return Axios.get('/supplierclientapi/suppliergoodstype/type_list', { params: params });
    };
    DeliverService.prototype.getGoodsInfo = function (params) {
        return Axios.get('/supplierclientapi/deliveryorder/goods_list', { params: params });
    };
    DeliverService.prototype.getdeliverNote = function (params) {
        return Axios.get('/supplierclientapi/deliveryorder/list_by_goods_ids', { params: params });
    };
    DeliverService.prototype.getEntrustdeliverNote = function (params) {
        return Axios.get('/supplierclientapi/entrust_delivery_order/list_by_goods_ids', { params: params });
    };
    DeliverService.prototype.saveLicese = function (params) {
        return Axios.post('/supplierclientapi/document/order_create_batch', params);
    };
    DeliverService.prototype.getSortingLabelList = function (params) {
        return Axios.get('/supplierclientapi/print/get_print_sorting_label', { params: params });
    };
    DeliverService.prototype.getDeliveryOrderQrcode = function (params) {
        return Axios.get('/supplierclientapi/deliveryorder/get_share_url', { params: params });
    };
    DeliverService.prototype.printSortingLabel = function (params) {
        return Axios.post('/supplierclientapi/print/print_sorting_label', params);
    };
    DeliverService.prototype.getUploadedDeliver = function (params) {
        return Axios.get('/supplierclientapi/deliveryorder/get_document_list', { params: params });
    };
    DeliverService.prototype.syncOrderDocument = function (params) {
        return Axios.get('/supplierclientapi/document/sync_order_document', { params: params });
    };
    DeliverService.prototype.aiCreateGoodInfo = function (params) {
        return Axios.post('/supplierclientapi/purchaseorder/ai_create', params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    };
    DeliverService.prototype.updatePredictGoods = function (params) {
        return Axios.post('/supplierclientapi/purchaseorder/update_predict_goods', params);
    };
    DeliverService.createInstance = function () {
        DeliverService.getInstance();
    };
    DeliverService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return DeliverService;
}());
export default DeliverService;
